var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "CreateBillingPlan",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              resourceTitle: _vm._f("pgettext")(
                "Billing Plan",
                "CreateBillingPlan|ResourceTitle"
              ),
              resourceKey: _vm._f("pgettext")(
                "Collect items",
                "CreateBillingPlan|ResourceKey"
              )
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                { attrs: { name: _vm.formName } },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "day",
                        labelColsMd: "3",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        required: "",
                        label: _vm._f("pgettext")(
                          "Target date",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "The date from which the system looks for billable items.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "day", required: "" },
                        model: {
                          value: _vm.item.day,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "day", $$v)
                          },
                          expression: "item.day"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "max_date",
                        labelColsMd: "3",
                        contentColsMd: "4",
                        labelAlign: _vm.labelAlign,
                        label: _vm._f("pgettext")(
                          "Max date",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "If no closing date is provided, items due within ten days of the specified date will be collected.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("ItpFormDatetime", {
                        attrs: { name: "max_date" },
                        model: {
                          value: _vm.item.max_date,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "max_date", $$v)
                          },
                          expression: "item.max_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "contracts",
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign,
                        label: _vm._f("pgettext")(
                          "Contracts",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Search for the selected contract's billable services.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("UcContractSelector", {
                        attrs: {
                          name: "contracts",
                          item: _vm.item,
                          path: "contracts",
                          multiple: "",
                          clearable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "companies",
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign,
                        label: _vm._f("pgettext")(
                          "Companies",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Search for the selected companies' services.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("UcCompanySelector", {
                        attrs: {
                          name: "companies",
                          item: _vm.item,
                          path: "companies",
                          multiple: "",
                          clearable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "tenants",
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign,
                        label: _vm._f("pgettext")(
                          "Partners",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Search for the selected partners' services.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("UcCompanySelector", {
                        attrs: {
                          name: "tenants",
                          item: _vm.item,
                          path: "tenants",
                          multiple: "",
                          clearable: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "rentals",
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign,
                        label: _vm._f("pgettext")(
                          "Rentals",
                          "CreateBillingPlan"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Search for the selected rentals' services.",
                          "CreateBillingPlan"
                        )
                      }
                    },
                    [
                      _c("UcRentalSelector", {
                        attrs: {
                          name: "rentals",
                          item: _vm.item,
                          path: "rentals",
                          multiple: "",
                          clearable: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("AsyncCommand", {
                staticClass: "ml-2",
                attrs: {
                  type: "submit",
                  size: "sm",
                  operation: "create_billing_plan",
                  payload: function() {
                    return _vm.getPayload(_vm.item)
                  },
                  variant: "primary",
                  icon: _vm.$config.processIcon,
                  text: _vm._f("pgettext")(
                    "Create billing plan",
                    "BillingList|Submit"
                  ),
                  form: _vm.forms[_vm.formName] && _vm.forms[_vm.formName].id
                },
                on: {
                  completed: function($event) {
                    return _vm.evh_1548630417156826_completed($event, {})
                  }
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Close", "CreateBillingPlan"),
                  variant: "default"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }